/**
 * tdesign v0.3.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { i as isUndefined_1 } from '../_chunks/dep-c9dcffa1.js';
import '../_chunks/dep-9fe8d051.js';

var canUseDom = !!(!isUndefined_1(window) && !isUndefined_1(document) && window.document && window.document.createElement);

export { canUseDom };
//# sourceMappingURL=canUseDom.js.map
